<form
  #searchForm
  class="resources-search-form"
  ngNoForm
  [action]="formAction"
  method="GET"
  id="resources-search-form"
  [attr.target]="!isResourcesPage ? 'resourcesWindow' : '_self'"
  (submit)="submitSearch()"
>
  <label for="query" class="cdk-visually-hidden">Search Resources</label>
  <input
    #searchInput
    class="resources-search-form__input"
    id="query"
    name="query"
    cignaInput
    type="text"
    placeholder="Search Resources"
    (focus)="isInputFocused = true"
    (blur)="isInputFocused = false"
  />
  <button
    cignaButton="link"
    class="resources-search-form__button"
    type="button"
    aria-label="Search"
    (click)="handleIconClick()"
  >
    <ng-leaf-icon-next
      name="search"
      category="system"
      weight="regular"
      size="16"
    ></ng-leaf-icon-next>
  </button>
</form>
